export default "__VITE_ASSET__a7e1934e__"